async function decryptionDone() {
    return new Promise((resolve, reject) => {
        let interval;
        interval = setInterval(() => {
            if (!$('.has-encrypted-content').length) {
                clearInterval(interval);
                resolve('decryptionDone');
                return;
            }
        }, 50);
    });
}
function setScroll(scroll) {
    window.scroll({
        top: scroll,
        behavior: 'instant'
    });
}
export function minimizableInitLoad(container) {
    if (!container) {
        container = document;
    }

    const textContainers = container.querySelectorAll('.minimizable');
    if (!textContainers.length) {
        return;
    }

    // Atveram tekstus uzreiz?
    let openedIds = JSON.parse(sessionStorage.getItem('opened_minimizables') || '[]');
    textContainers.forEach(container => {

        // Ja blakus jau ir "Lasīt vairāk" poga, tad šis teksts jau ir apstrādāts, ejam tālāk
        if (container.nextElementSibling?.classList.contains('maximize')) return;

        const textId = container.closest('[data-id]')?.getAttribute('data-id');
        if (textId) {
            container.dataset.id = textId; // Saglabājam ID datu atribūtā, lai vēlāk varētu pārbaudīt
        }

        if (!textId) return; // Ja nav ID, nevaram saglabāt atvērtos, tāpēc neapstrādājam
        const maximized = openedIds.includes(textId);
        if (!maximized) return;

        // Izveidojam pogu
        const btn = document.createElement('button');
        btn.textContent = '';
        btn.className = 'maximize' + (maximized ? ' opened' : ''); // Šeit varēsi uzlikt savu CSS dizainu

        if (maximized) {
            container.classList.add('opened');
        } else {
            container.classList.add('can-open');
        }

        // Ievietojam pogu uzreiz aiz paša teksta konteinera
        container.after(btn);
    });
}

export async function minimizableInit(container) {
    if (!container) {
        container = document;
    }

    const textContainers = container.querySelectorAll('.minimizable');
    if (!textContainers.length) {
        return;
    }

    //await crypterReady(appState.globalCrypter);
    await decryptionDone();

    document.fonts.ready.then(() => {
        setTimeout(() => {
            // Nolasām jau atvērtos ID no sesijas (ja nav, izveidojam tukšu masīvu)
            let openedIds = JSON.parse(sessionStorage.getItem('opened_minimizables') || '[]');
            textContainers.forEach(container => {

                // Ja blakus jau ir "Lasīt vairāk" poga, tad šis teksts jau ir apstrādāts, ejam tālāk
                if (container.nextElementSibling?.classList.contains('maximize')) return;
                if (container.scrollHeight - 4 <= container.clientHeight) {
                    // Teksts nav garāks par redzamo, nav ko minimizēt, ejam tālāk
                    container.classList.add('cant-open');
                    return;
                }

                const textId = container.closest('[data-id]')?.getAttribute('data-id');
                if (textId) {
                    container.dataset.id = textId; // Saglabājam ID datu atribūtā, lai vēlāk varētu pārbaudīt
                }
                container.dataset.originalHeight = container.clientHeight; // Saglabājam oriģinālo augstumu, lai varētu atjaunot

                if (!textId) return; // Ja nav ID, nevaram saglabāt atvērtos, tāpēc neapstrādājam
                const maximized = openedIds.includes(textId);

                // Izveidojam pogu
                const btn = document.createElement('button');
                btn.textContent = '';
                btn.className = 'maximize' + (maximized ? ' opened' : ''); // Šeit varēsi uzlikt savu CSS dizainu

                if (maximized) {
                    container.classList.add('opened');
                } else {
                    container.classList.add('can-open');
                }

                // Force reflow
                //void container.offsetHeight;

                // Ievietojam pogu uzreiz aiz paša teksta konteinera
                container.after(btn);
            });
        }, 20);
    });
}
/* document.addEventListener("DOMContentLoaded", () => {
    minimizableInitLoad(document);
}); */
document.addEventListener('click', (e) => {
    // Pārbaudām, vai klikšķis bija tieši uz mūsu "Lasīt vairāk" pogas
    if (e.target && /** @type {Element} */ (e.target).matches('.maximize')) {
        const btn = /** @type {HTMLElement} */ (e.target);

        // Tā kā pogu ievietojām ar container.after(btn), teksta bloks ir tās iepriekšējais "kaimiņš"
        const container = /** @type {HTMLElement} */ (btn.previousElementSibling);

        if (!container || !container.classList.contains('minimizable')) return;

        const textId = container.dataset.id;
        const open = container.classList.contains('opened');

        let getOriginalHeight = (elem) => {
            elem.dataset.originalHeight = $(elem).closest('.chatItem').data('glow') == 1 ? 242 : 230;
            return elem.dataset.originalHeight;
        };

        let openedIds = JSON.parse(sessionStorage.getItem('opened_minimizables') || '[]');
        if (open) {
            // Ja jau ir atvērts, tad aizveram - atjaunojam augstuma ierobežojumu un masku
            container.style.maxHeight = container.scrollHeight + 'px';

            const currentHeight = container.scrollHeight;
            const originalHeight = parseInt(container.dataset.originalHeight || getOriginalHeight(container), 10);
            const heightDiff = currentHeight - originalHeight;
            const prevScroll = window.scrollY;
            const targetScroll = window.scrollY - heightDiff;

            $(container).animate({
                maxHeight: originalHeight
            }, {
                duration: 500,
                step: function (now, tween) {
                    setScroll(prevScroll - heightDiff * tween.pos);
                },
                complete: function () {
                    setScroll(targetScroll);
                }
            });

            container.classList.remove('opened');
            btn.classList.remove('opened');
            openedIds = openedIds.filter(id => id !== textId); // Noņemam no atvērtajiem
        } else {
            // Ja nav atvērts, tad atveram
            $(container).animate({
                maxHeight: container.scrollHeight
            }, {
                duration: 500,
                complete: function () {
                    container.classList.add('opened');
                    container.style.maxHeight = 'none';
                }
            });

            btn.classList.add('opened');
            //openedIds = openedIds.filter(id => id !== textId);
            openedIds.push(textId);
        }
        sessionStorage.setItem('opened_minimizables', JSON.stringify(openedIds));
    }
});

export {};